import { Component, OnInit, ViewChild, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'ngx-import-csv',
  templateUrl: './import-csv.component.html',
  styleUrls: ['./import-csv.component.scss']
})
export class ImportCsvComponent implements OnInit {
  @ViewChild('fileInput', null) fileInput;
  @ViewChild('fileLabel', null) fileLabel;

  @Output() callbackFunction: EventEmitter<any> = new EventEmitter();
  @Output() afterCallbackFunction: EventEmitter<any> = new EventEmitter();


  constructor(private notificationsService: NotificationsService) {
  }

  ngOnInit() {
  }

  importarCSV(fileList: FileList): any {
    let fileInfo: any = fileList[0];
    this.fileLabel.nativeElement.innerText = fileInfo.name;
    let reader: any = new FileReader();

    reader.readAsText(fileInfo);
    reader.onload = (data) => {
      let matriz: any = [];

      let csvData: any = reader.result;
      let csvRecordsArray: any = String(csvData).split(/\r\n|\n/);
      let header: any = csvRecordsArray[0].split(',');
      for (let cont = 1; cont < csvRecordsArray.length; cont++) {
        let line: any = csvRecordsArray[cont].split(',').filter((record) => record != null && record.trim().length > 0)
        if (line.length > 0 ) {

          let jsonObj: any = {};
          for (let index = 0; index < line.length; index++) {
            jsonObj[header[index]] = line[index]
          }
          matriz.push(jsonObj);
        }
      }
      let csvInfo: any = {
        data: matriz,
        fileName: fileInfo.name,
      };
      this.callbackFunction.emit(csvInfo);
      if (this.afterCallbackFunction) this.afterCallbackFunction.emit(null);

    }

  }

}
